// src/app/modules/Dashboard/_redux/dashboard/Actions.js
import * as requestFromServer from "./Crud";
import { toast } from "react-toastify";
import { DashboardSlice, callTypes } from "./Slice";
const { actions } = DashboardSlice;


export const fetchDangerZones = (params) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getDangerZones(params)
    .then(response => {
      const {incidents} = response.data; // Adjust based on your API response structure
      // console.log(incidents);
      dispatch(actions.dangerZonesFetched(incidents || []));
    })
    .catch(error => {
      console.log("EEEEEEEE")
      toast.error("Failed to load danger zones");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

/**
 * SUBMIT DANGER ZONE REPORT
 * Dispatched from the sidebar form
 */
export const createDangerZoneReport = (reportData) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .submitDangerZoneReport(reportData)
    .then(response => {
      const { data } = response.data;
      // dispatch(actions.dangerZoneAdded(data));
      toast.success("Incident Broadcasted Successfully");
      return data;
    })
    .catch(error => {
      const message = error.response?.data?.message || "Could not submit report";
      toast.error(message);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};